import React from 'react';
import { View, StyleSheet, Image, TouchableOpacity } from 'react-native';
import { PnmacText } from 'pnmac-universal-components';
import { textStyle } from '../v2/theme';
export default function PnmacOfferTiles(props) {
  return /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: function () {
      if (props.onPress) {
        props.onPress();
      }
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles.mainContainer, {
      width: props.customWidth ? props.customWidth : 150,
      height: 166,
      marginRight: props.item.index > 0 ? props.customMarginRight : 0
    }]
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      position: "absolute",
      top: 15,
      left: 15,
      paddingRight: 10
    }
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: [textStyle.accordionItem, {
      textAlign: "left",
      fontSize: 13,
      fontWeight: "bold",
      color: "#333333"
    }]
  }, props.title), /*#__PURE__*/React.createElement(PnmacText, {
    style: [textStyle.accordionItem, {
      textAlign: "left",
      fontSize: 13,
      fontWeight: null,
      fontFamily: "HalenoirCompactText-Regular",
      marginTop: 5,
      color: "#1B1B1B"
    }]
  }, props.description)), /*#__PURE__*/React.createElement(View, {
    style: styles.iconContainer
  }, /*#__PURE__*/React.createElement(Image, {
    style: styles.iconStyle,
    resizeMode: "contain",
    source: props.item.icon
  }))));
}
;
var styles = StyleSheet.create({
  mainContainer: {
    justifyContent: 'space-around',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.1,
    shadowColor: "#777777",
    shadowRadius: 5,
    elevation: 1,
    borderRadius: 5,
    backgroundColor: "#FFFFFF",
    padding: 10,
    margin: 10
  },
  iconContainer: {
    position: "absolute",
    bottom: 15,
    right: 15
  },
  iconStyle: {
    width: 41,
    height: 40
  }
});